import {
  dangerColor,
  whiteColor,
  secondaryColor
} from "@themes/defaultThemeProps";
import {cardTitle} from "assets/jss/material-dashboard-pro-react.js";
import buttonGroupStyle from "assets/jss/material-dashboard-pro-react/buttonGroupStyle.js";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";
import hoverCardStyle from "assets/jss/material-dashboard-pro-react/hoverCardStyle.js";
import commonStyle from "assets/jss/material-dashboard-pro-react/commonStyle";

const userEditStyle = {
  ...commonStyle,
  ...hoverCardStyle,
  ...customCheckboxRadioSwitch,
  ...buttonGroupStyle,

  cardTitle: {
    ...cardTitle,
    color: whiteColor,
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  chip: {
    margin: 3,
  },
  formCategory: {
    marginBottom: "0",
    color: secondaryColor[0],
    fontSize: "14px",
    padding: "10px 0 10px",
  },
  center: {textAlign: "center"},
  justifyContentCenter: {justifyContent: "center"},
  registerButton: {float: "right"},
  keyButton: {float: "left"},
  leftButton: {float: "left"},
  danger: {color: `${dangerColor[0]} !important`},
  right: {textAlign: "right"},
  description: {maxWidth: "150px"},
  actionButton: {
    margin: "0 0 0 5px",
    padding: "5px",
    "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      marginRight: "0px",
    },
  },
  icon: {
    verticalAlign: "middle",
    width: "17px",
    height: "17px",
    top: "-1px",
    position: "relative",
  },
  imgContainer: {
    width: "120px",
    maxHeight: "160px",
    overflow: "hidden",
    display: "block",
  },
  img: {
    width: "100%",
    height: "auto",
    verticalAlign: "middle",
    border: "0",
  },
  tdName: {
    minWidth: "200px",
    fontWeight: "400",
    fontSize: "1.5em",
  },
  tdNameAnchor: {color: secondaryColor[2]},
  tdNameSmall: {
    color: secondaryColor[0],
    fontSize: "0.75em",
    fontWeight: "300",
  },
  tdNumber: {
    textAlign: "right",
    minWidth: "145px",
    fontWeight: "300",
    fontSize: "1.3em !important",
  },
  tdNumberSmall: {marginRight: "3px"},
  tdNumberAndButtonGroup: {lineHeight: "1 !important"},
  positionAbsolute: {
    position: "absolute",
    right: "0",
    top: "0",
  },
  customFont: {fontSize: "16px !important"},
  actionButtonRound: {
    width: "auto",
    height: "auto",
    minWidth: "auto",
  },
  formControl: {
    marginTop: 12,
    marginBottom: 12,
    marginLeft: 20,
    minWidth: 180,
  },
  formControlInline: {
    marginTop: 12,
    marginLeft: 0,
    minWidth: 180,
    width: "100%",
  },
  formControlLabel: {
    lineHeight: "1 !important",
    fontSize: "0.75rem",
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.54)",
  },
  spanBold: {fontWeight: "bold"},

  // for the new style
  transparentCard: {background: "transparent"},
  whiteBackground: {background: "white"},

  padding20: {padding: "20px"},
  paddingHorizontal20: {paddingLeft: "20px", paddingRight: "20px"},

  cardBody: {
    padding: 0,
    background: "transparent"
  },

  cardHeader: {
    background: "white !important",
    margin: "0 !important",
    paddingBottom: "20px !important",
    paddingRight: "20px !important",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
    '& > #environment-info': {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "auto"
    },
    '& > #activate-env': {
      marginTop: '20px'
    },
  },


  cardIcon: {
    marginLeft: "20px"
  },

  regularTab: {
    background: "white !important",
    paddingLeft: "20px",
    paddingRight: "20px"
  },

  boxTabContent: {
    padding: '20px',
    backgroundColor: "white",
  },

  productAttributesCard: {
    marginTop: "530px"
  }

};

export default userEditStyle;


